import { SSOErrorPage } from 'auth/pages'

export default function SSOError() {
  return <SSOErrorPage />
}
